<template>
  <div class="count" v-loading="loading">
    <div>
      <div class="tabCard">
        <ul class="optionList clearfix" style="margin-top: 20px;">
          <li class="option-item">
            <span class="label">区域</span>
            <el-select v-model="regionValue" placeholder="请选择" multiple collapse-tags @change="selectRegions">
              <el-option v-for="item in regionOptions" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="option-item">
            <span class="label">排水户性质</span>
            <el-select v-model="comInsTypeValue" placeholder="请选择" id="comProId" :disabled="comInsTypeDis">
              <el-option v-for="item in proOptions" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="option-item">
            <span class="label">排水户类型</span>
            <el-select v-model="comTypeValue" placeholder="请选择" id="comTypeId" :disabled="comTypeDis">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="option-item">
            <span class="label">发证情况</span>
            <el-select v-model="licenseState" placeholder="请选择" id="licenseStateId" :disabled="licenseStateDis">
              <el-option v-for="item in stateOptions" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="option-item">
            <span class="label">检查情况</span>
            <el-select v-model="inspectState" placeholder="请选择" id="inspectStateId" :disabled="inspectSelectDis">
              <el-option v-for="item in inspectOptions" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="option-item">
            <span class="label">时间</span>
            <el-date-picker v-model="applyDate_s" type="daterange" unlink-panels format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" :picker-options="pickerOptions1">
            </el-date-picker>
          </li>
          <li class="option-item" style="position: absolute;right: 0;text-align: right;top: 52px;">
            <el-button type="primary" @click="statisticsData()">查询</el-button>
          </li>
        </ul>
        <ul class="optionList clearfix">

        </ul>
        <ul class="optionList taboptionList clearfix">
          <li class="option-item" id="statisticsCategoryId">
            <span class="label">统计类别</span>
            <el-radio-group v-model="statisticsCategory" @change="statisticsCategoryChange">
              <el-radio-button label="区域"></el-radio-button>
              <el-radio-button label="排水户性质"></el-radio-button>
              <el-radio-button label="排水户类型"></el-radio-button>
              <el-radio-button label="发证情况"></el-radio-button>
              <el-radio-button label="检查情况"></el-radio-button>
            </el-radio-group>
          </li>

        </ul>
        <div class="chart-wrapper" :style='styleObject' style="margin-top:60px;" id="myChart"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CountMain',
  data() {
    return {
      //加载图标
      loading: true,
      // -- 统计选择的值 ---
      regionValue: [],
      regionValueD: [], //不可变
      regionsLength: 0, //全局集合长度
      regionsVariableLength: 0, //全局集合长度变量
      regionOptions: [],
      //排水户性质
      comInsTypeValue: '全部',
      proOptions: [{
        value: '全部'
      }, {
        value: '一般排水户'
      },
        {
          value: '重点排水户'
        }
      ],
      //排水户类型
      comTypeValue: '全部',
      typeOptions: [{
        value: '全部'
      }, {
        value: '居民'
      }, {
        value: '工业'
      }, {
        value: '商业'
      }],
      //发证情况
      licenseState: '全部',
      stateOptions: [{
        label: '全部',
        value: '全部'
      }, {
        label: '未发证',
        value: '1'
      }, {
        label: '已发证',
        value: '5'
      }],
      //检查情况
      inspectState: '全部',
      inspectOptions: [{
        label: '全部',
        value: '全部'
      }, {
        label: '合格',
        value: '0'
      },
        {
          label: '不合格',
          value: '1'
        }
      ],
      applyDate_s: [],
      // 所属大平台单位id
      platformCompanyId: '',         
      //统计类别
      statisticsCategory: '区域',
      // 排水户列表申请日期选项
      pickerOptions1: {
        shortcuts: [{
          text: '最近一个月',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            // 本月第一天日期
            var begin = year + "-" + month + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            //判断如果当前月份小于3月
            if (month < 3) {
              var year1 = year - 1;
              var month1 = 12 + parseInt(month) - 2;
            } else {
              var year1 = year;
              var month1 = month - 2;
            }
            // 本月第一天日期
            var begin = year1 + "-" + month1 + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            var date = new Date();
            var year = date.getFullYear() + "";
            var month = (date.getMonth() + 1) + "";
            //判断如果当前月份小于6月
            if (month < 6) {
              var year1 = year - 1;
              var month1 = 12 + parseInt(month) - 5;
              if (month1 < 10) {
                month1 = "0" + month1;
              }
            } else {
              var year1 = year;
              var month1 = month - 5;
            }
            // 本月第一天日期
            var begin = year1 + "-" + month1 + "-01";
            // 本月最后一天日期    
            var lastDateOfCurrentMonth = new Date(year, month, 0);
            var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
            var startDay = new Date(begin);
            var endDay = new Date(end);
            picker.$emit('pick', [startDay, endDay]);
          }
        }]
      },
      styleObject: {
        height: window.innerHeight - 60 - 40 - 20 - 20 - 80 - 150 + 'px'
      },
      //检查情况下拉框是否不可编辑
      inspectSelectDis: false,
      //排水户性质下拉框是否不可编辑
      comInsTypeDis: false,
      //排水户类型下拉框是否不可编辑
      comTypeDis: false,
      //发证情况下拉框是否不可编辑
      licenseStateDis: false,
      //扇形图图例
      statisticsLegend: [],
      //扇形图数据
      graphData: []
    }
  },
  components: {
    // pagination
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.tableHeight = window.innerHeight - 60 - 40 - 20 - 20 - 80 - 150 + 'px'
        that.tableHeight = window.tableHeight
      })()
    }
    // 获取所属大平台单位id
    var companyInfo = sessionStorage.getItem('drainage-companyInfo');
    if (companyInfo) {
      this.platformCompanyId = JSON.parse(companyInfo).CompanyId;
    } else {
      this.$message({
        type: 'error',
        message: '登录信息过期，请重新登录'
      });
      this.$router.push({
        path: '/login'
      });
    }       
    this.getNowTime();
    this.regionOptions = this.filterRegion();
    this.regionsLength = this.regionOptions.length;
    this.regionsVariableLength = this.regionOptions.length;
    var i;
    for (i in this.regionOptions) {
      this.regionValue.push(this.regionOptions[i].value);
    }
    this.regionValueD = this.regionValue;
    //			this.regionValue = this.regionOptions[0].value;
    this.statisticsData();
  },
  methods: {
    // 设置默认日期
    getNowTime() {
      var dateArray = this.getMonthFirsetLastDay();
      var startDay = this.time2YMD(new Date(dateArray[0]).getTime());
      var endDay = this.time2YMD(new Date(dateArray[1]).getTime());
      this.applyDate_s = [startDay, endDay];
    },
    //区域选项发生变化时执行此方法
    selectRegions(val) {
      if (val.length > 0) {
        //										debugger;
        //选择后集合不包括全选'-1'且选择后的长度等于原始长度减去1并且变量长度等于原始长度，说明第一次点击全选，应清空
        if (val.indexOf('全部') == -1 && this.regionsLength - 1 == val.length && this.regionsVariableLength == this.regionsLength) {
          this.regionValue = [];
        }
        //集合最后一项包含-1说明点击了全选按钮应对全选
        if (val.indexOf('全部') != -1 && '全部' == val[val.length - 1]) {
          this.regionValue = this.regionValueD;
        }
        //如果选择后当前选择为集合最大长度，并且不包含’-1‘，则说明选中了所有项则全选应自动选中
        if (val.indexOf('全部') == -1 && val.length == this.regionsLength - 1 && this.regionsVariableLength != this.regionsLength) {
          this.regionValue = this.regionValueD;
        }
        //如果包含'-1'并且长度小于等于集合的长度则把'-1'从集合中去掉
        if (val.indexOf('全部') != -1 && '全部' != val[val.length - 1] && val.length <= this.regionsLength - 1) {
          var arr = [];
          var x;
          for (x in val) {
            if ('全部' != val[x]) {
              arr.push(val[x]);
            }
          }
          this.regionValue = arr;
        }
        this.regionsVariableLength = this.regionValue.length;
      }
    },
    //统计类别按钮发生变化时执行该方法
    statisticsCategoryChange() {
      //				debugger
      if (this.statisticsCategory == "排水户性质") {
        this.comInsTypeDis = true;
        this.comInsTypeValue = "全部";
      } else {
        this.comInsTypeDis = false;
      }

      if (this.statisticsCategory == "排水户类型") {
        this.comTypeDis = true;
        this.comTypeValue = "全部";
      } else {
        this.comTypeDis = false;
      }

      if (this.statisticsCategory == "发证情况") {
        this.licenseStateDis = true;
        this.inspectSelectDis = false;
        this.licenseState = "全部";
      } else {
        this.licenseStateDis = false;
      }

      if (this.statisticsCategory == "检查情况") {
        this.licenseStateDis = true;
        this.inspectSelectDis = true;
        this.licenseState = "已发证";
        this.inspectState = "全部";
      } else if (this.statisticsCategory != "发证情况") {
        this.licenseStateDis = false;
        this.inspectSelectDis = false;
      }
      this.statisticsData();
    },
    statisticsData() {
      this.loading = true;
      //清空扇形图数据和图例
      this.graphData = [];
      this.statisticsLegend = [];
      var startDate = '';
      var endDate = '';
      if (this.applyDate_s && this.applyDate_s.length > 0) {
        startDate = this.applyDate_s[0];
        endDate = this.applyDate_s[1];
      }
      var arr = [];
      if (this.regionValue.indexOf('全部') != -1) {
        var x;
        for (x in this.regionOptions) {
          if ('全部' != this.regionOptions[x].value) {
            arr.push(this.regionOptions[x].value);
          }
        }
      } else {
        arr = this.regionValue;
      }
      var stype = '';
      if (this.statisticsCategory == '区域') {
        stype = 'region';
      } else if (this.statisticsCategory == '排水户性质') {
        stype = 'sewerageindustrytype';
      } else if (this.statisticsCategory == '排水户类型') {
        stype = 'seweragetype';
      } else if (this.statisticsCategory == '发证情况') {
        stype = 'licensestate';
      } else if (this.statisticsCategory == '检查情况') {
        stype = 'ifqualified';
      }
      this.$http.post(this.basePath + '/sewerageUser/statisticsData/', {
        //  参数
        platformCompanyId: this.platformCompanyId,
        applyDateStart: startDate,
        applyDateEnd: endDate,
        region: JSON.stringify(arr),
        sewerageindustrytype: JSON.stringify(this.comInsTypeValue),
        seweragetype: JSON.stringify(this.comTypeValue),
        licensestate: JSON.stringify(this.licenseState),
        ifqualified: JSON.stringify(this.inspectState),
        stype: stype
      }).then((result) => {
        //					debugger
        if (result.data.resCode == 1) {
          if (result.data.data != '') {
            var valData = JSON.parse(result.data.data);
            for (var i in valData) {
              var obj = valData[i];
              this.statisticsLegend.push(obj.type);
              var pobj = {};
              pobj.name = obj.type;
              pobj.value = obj.val;
              this.graphData.push(pobj);
            }
            this.drawLine(valData);
          } else {
            this.drawLine(null);
            //							alert('获取数据为空！')
            this.$message({
              type: 'warning',
              message: '获取数据为空'
            });
          }
        } else {
          //						alert(result.data.msg);
          this.$message({
            type: 'error',
            message: result.data.msg
          });
        }
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }, (error) => {
        setTimeout(() => {
          this.loading = false;
        }, 300);
        //					alert('error');
        this.$message({
          type: 'error',
          message: 'error'
        });
      });
    },
    /**
     * 排水户数量、各个类型数量
     */
    drawLine(valData) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      if (valData == null) {
        myChart.clear();
        return false;
      }
      var xAxisArr = [],
      paishuihuNum = [],
      zhongdNum = [],
      yibanNum = [],
      qitaNum = [],
      licenSumNum = [],
      yifazhengNum = [],
      weifazhengNum = [],
      inspectSumNum = [],
      inspectYesNum = [],
      inspectNoNum = [],
      residentNum = [],
      industryNum = [],
      businessNum = [];
      for (var i = 0; i < valData.length; i++) {
        var data = valData[i];
        xAxisArr.push(data.region);
        paishuihuNum.push(data.paishuihuNum);
        zhongdNum.push(data.zhongdNum);
        yibanNum.push(data.yibanNum);
        qitaNum.push(data.qitaNum);
        licenSumNum.push(data.licenSumNum);
        yifazhengNum.push(data.yifazhengNum);
        weifazhengNum.push(data.weifazhengNum);
        inspectSumNum.push(data.inspectYesNum + data.inspectNoNum);
        inspectYesNum.push(data.inspectYesNum);
        inspectNoNum.push(data.inspectNoNum);
        residentNum.push(data.resident);
        industryNum.push(data.industry);
        businessNum.push(data.business);
      }
      var option = {
        color: ['#36C75E', '#FDBD00', '#4285F4', '#9013FE','#5867DD'],
        title: {
          text: '排水户数据统计',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          data: this.statisticsLegend
        },
        toolbox: {
          show: true,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: false
            },
            //							magicType: {
            //								show: true,
            //								type: ['pie', 'funnel'],
            //								option: {
            //									funnel: {
            //										x: '25%',
            //										width: '50%',
            //										funnelAlign: 'left',
            //										max: 1548
            //									}
            //								}
            //							},
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: true,
        series: [{
          name: this.statisticsCategory,
          type: 'pie',
          radius: '80%',
          center: ['50%', '55%'],
          data: this.graphData
        }]
      };
      myChart.setOption(option);
    }
  }
}
</script>
<style lang="stylus" scoped>
  .tabCard >>> .el-tabs__nav.is-stretch {
    display: inherit;
  }

  .tabCard >>> .el-tabs--card > .el-tabs__header .el-tabs__nav,
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: none;
    border-radius: 0;
  }

  .tabCard >>> .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #E2E7EB;
  }

  .tabCard >>> .el-tabs__item {
    height: 50px;
    line-height: 50px;
    padding: 0 30px;
    border-radius: 2px 2px 0 0;
    font-size: 15px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;

    &:first-child {
      margin-left: 27px;
    }
  }

  .tabCard >>> .el-tabs__item.is-active {
    background: #3E82F7;
    color: #fff;
  }

  .tabCard >>> .el-tabs__header {
    margin: 0;
    padding-top: 10px;
  }

  .count .optionList >>> .label {
    display: block;
    font-size: 12px;
    color: #262626;
    margin-right: 10px;
    line-height: 36px
  }

  .count .optionList >>> .el-input__inner {
    flex 1
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #262626;
    border: 1px solid #D3D9DB;
    position: relative;
  }

  .count .optionList >>> .el-date-editor--daterange.el-input__inner {
    flex 1
    position: relative;
  }

  .count .optionList >>> .el-button {
    font-size: 12px;
    border-radius: 2px;
  }

  .count .optionList >>> .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    flex 1
  }

  .count .optionList >>> .el-input {
    flex 1
  }

  .taboptionList >>> .label {
    display: block;
    font-size: 12px;
    color: #262626;
    margin-right: 10px;
    line-height: 36px
  }
  .optionList >>> .el-date-editor--daterange.el-input__inner {
    width: 180px
  }

  .optionList {
    margin: 0px 0 0px 20px;
    display flex

    .option-item {
      /*flex 1;*/
      width: 12%
      margin-right: 15px;
    }

  }

  .taboptionList {
    margin: 0px 0 20px 20px;
    display flex

    .option-item {
      flex 1;
      display flex
      width: 12%
      margin-right: 15px;
    }
  }

  .chart-wrapper {
    margin: 0 20px;
    // background-color: #ccc;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #ebeef5;
    border-color: #262626;
    color: #262626;
    cursor: not-allowed;
  }

  .image {
    width: 100%;
    height: 100%;
  }


  #comProId {
    width: 110px;
  }

  #comTypeId {
    width: 90px;
  }

  #licenseStateId {
    width: 90px;
  }

  #inspectStateId {
    width: 90px;
  }

  #statisticsCategoryId {
    margin-top: 20px;
    width: 80%
  }
</style>



// WEBPACK FOOTER //
// src/components/count/components/countMain.vue